import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { AVAILABLE_FOR_YOU } from 'types/morph.pagePosition.constants';

import './OfferCard.scss';

export const OfferCard = ({
  badgeLabel,
  offerTitle,
  offerUrl,
  extraDetails,
  offerSubtitle,
  history,
  eventHandler,
  clickType,
  modulePosition,
}) => {
  const handleOfferClick = offerUrl => {
    eventHandler(CLICK, {
      'Click Type': clickType,
      'Module Position': modulePosition,
      'Module Name': AVAILABLE_FOR_YOU,
    });
    history.push(offerUrl);
  };

  return (
    <FlexContainer
      className="offerCard flex-column items-align-center pointer gap-16"
      onClick={() => handleOfferClick(offerUrl)}
    >
      <FlexContainer className="flex-column align-items-center">
        <Label className="bold text-16">{offerTitle}</Label>
        {offerSubtitle && (
          <Label
            type="Subtitle-3"
            color="secondary_text_light"
            className="Body-2 otherLink width100 height16px text-center notBold"
          >
            {offerSubtitle}
          </Label>
        )}
      </FlexContainer>
      <FlexContainer className="flex-column align-items-center gap-4">
        {badgeLabel && (
          <Label className="badge padTB6 padLR8">{badgeLabel}</Label>
        )}
        {extraDetails && <Label className="text-12">{extraDetails}</Label>}
      </FlexContainer>
    </FlexContainer>
  );
};
